//reported user [to user]
export const GET_REPORTED_USER = "GET_REPORTED_USER";

export const BLOCK_UNBLOCK_HOST = "BLOCK_UNBLOCK_HOST";
